import Enumerator from '../global/Enumerator';

export const otherAdviserTypes = [
  'accountant',
  'solicitor',
  'real_estate_agent',
  'financial_advisor',
  'general_insurance_agent'
];

export class OtherAdviserType extends Enumerator {
  static default() {
    return this.of('accountant');
  }
}

OtherAdviserType.initEnum({
  accountant: {
    get id() {
      return 'accountant';
    },
    get title() {
      return 'Accountant';
    },
    get weight() {
      return 1;
    }
  },
  solicitor: {
    get id() {
      return 'solicitor';
    },
    get title() {
      return 'Solicitor';
    },
    get weight() {
      return 2;
    }
  },
  real_estate_agent: {
    get id() {
      return 'real_estate_agent';
    },
    get title() {
      return 'Real estate agent';
    },
    get weight() {
      return 3;
    }
  },
  financial_advisor: {
    get id() {
      return 'financial_advisor';
    },
    get title() {
      return 'Financial advisor';
    },
    get weight() {
      return 4;
    }
  },
  general_insurance_agent: {
    get id() {
      return 'general_insurance_agent';
    },
    get title() {
      return 'General insurance agent';
    },
    get weight() {
      return 5;
    }
  },
  primary_banker: {
    get id() {
      return 'primary_banker';
    },
    get title() {
      return 'Primary banker';
    },
    get weight() {
      return 6;
    }
  }
});

export default {
  otherAdviserTypes,
  OtherAdviserType
};
